<template>
  <form novalidate>
    <h4 class="h4 text--bold text--uppercase">
      Sobre las personas que participaron en la visita a la propiedad
    </h4>
    <div v-if="!seguimiento" class="form__group">
      <label class="form__label form__label--required">
        {{indice}}. Nombre y teléfono de la persona con quien se realizó la visita y
        recorrido en la propiedad hoy
      </label>
      <div class="identado">
        <form-group :error="errors.has('nomPersonaAcompanante') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.nomPersonaAcompanante"
          name="nomPersonaAcompanante"
          required
          v-validate="'required'">
          <label class="form__label" for="nomPersonaAcompanante">
            Nombre
          </label>
        </form-group>
        <form-group :error="errors.has('telPersonaAcompanante') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.telPersonaAcompanante"
          name="telPersonaAcompanante"
          required
          v-validate="'required'">
          <label class="form__label" for="telPersonaAcompanante">
            Teléfono
          </label>
        </form-group>
      </div>
    </div>

    <div v-if="!seguimiento" class="form__group">
      <label class="form__label form__label--required">
        {{indice+1}}. Nombre y teléfono de la persona más indicada para contactar en futuras visitas
        o acciones de seguimiento
      </label>
      <button type="button" class="boton boton--s boton--grise" @click="copiarAcompanante">
        <i class="fas fa-fw fa-copy"/>
        Copiar anterior
      </button>
      <div class="identado">
        <form-group :error="errors.has('nomPersonaContacto') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.nomPersonaContacto"
          name="nomPersonaContacto"
          required
          v-validate="'required'">
          <label class="form__label" for="nomPersonaContacto">
            Nombre
          </label>
        </form-group>
        <form-group :error="errors.has('telPersonaContacto') && submitted">
          <input
          data-vv-validate-on="blur"
          :disabled="!editando"
          type="text"
          class="form__input"
          v-model="form.telPersonaContacto"
          name="telPersonaContacto"
          required
          v-validate="'required'">
          <label class="form__label" for="telPersonaContacto">
            Teléfono
          </label>
        </form-group>
    </div>
    </div>

    <div class="mt-8">
      <label class="form__label form__label--required">
        {{seguimiento ? indice : indice+2}}.
        Nombre de los demás funcionarios o inspectores que participaron de la visita
      </label>

      <div class="checkbox checkbox--azul mt-4">
        <input
          :disabled="!editando"
          type="checkbox"
          id="visita-solo"
          v-model="form.visitaSolo"
        >
        <label class="form__label" for="visita-solo">
          No aplica, porque hice la visita solo (a)
        </label>
      </div>

      <div v-if="!form.visitaSolo" class="identado">
        <form-group :error="errors.has('funcionario-extra') && submitted">
          <input
            data-vv-validate-on="blur"
            :disabled="!editando"
            type="text"
            class="form__input"
            v-model="form.funcionariosParticipantes[0]"
            name="funcionario-extra"
            required
            v-validate="'required'"
          >
          <label class="text">1.</label>
        </form-group>
        <form-group>
          <input
            data-vv-validate-on="blur"
            :disabled="!editando"
            type="text"
            class="form__input"
            v-model="form.funcionariosParticipantes[1]"
          >
          <label class="text">2.</label>
        </form-group>
        <form-group>
          <input
            data-vv-validate-on="blur"
            :disabled="!editando"
            type="text"
            class="form__input"
            v-model="form.funcionariosParticipantes[2]"
          >
          <label class="text">3.</label>
        </form-group>
      </div>
    </div>

    <h4 class="h4">Firma del funcionario titular de la inspección</h4>

    <form-group :error="errors.has('nomFuncionario') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.nomFuncionario"
      name="nomFuncionario"
      required
      v-validate="'required'">
      <label class="form__label" for="nomFuncionario">
        {{seguimiento ? indice+1 : indice+3}}. Nombre del funcionario
      </label>
    </form-group>

    <form-group :error="errors.has('cedFuncionario') && submitted">
      <input
      data-vv-validate-on="blur"
      :disabled="!editando"
      type="text"
      class="form__input"
      v-model="form.cedFuncionario"
      name="cedFuncionario"
      required
      v-validate="'required'">
      <label class="form__label" for="cedFuncionario">
        {{seguimiento ? indice+2 : indice+4}}. Cédula del funcionario
      </label>
    </form-group>

    <form-group :error="errors.has('fechaSubida')">
      <datetime
        :disabled="!editando"
        v-model="form.fechaSubida"
        v-validate="'required'"
        :use12-hour="true"
        input-class="form__input"
        name="fechaSubida"
        value-zone="local"
        type="date"/>
      <label class="form__label form__label--required">
        {{seguimiento ? indice+3 : indice+5}}.
        Fecha del día de hoy (día en que se terminó/subió el formulario)
      </label>
    </form-group>

    <form-group :error="errors.has('hora-finalizacion')">
      <datetime
        v-model="form.horaFinalizacion"
        v-validate="'required'"
        :disabled="!editando"
        :use12-hour="true"
        format="t"
        input-class="form__input"
        name="hora-finalizacion"
        title="Hora de finalización"
        type="time"
        value-zone="local"
      />
      <label class="form__label form__label--required">
        {{seguimiento ? indice+4 : indice+6}}. Hora de finalización de la gira
      </label>
    </form-group>

    <form-group class="mb-4">
      <input
        class="form__input"
        disabled
        :value="horasFuncionario"
      >
      <span class="text text--gris8">
        {{seguimiento ? indice+5 : indice+7}}. Horas funcionario
      </span>
    </form-group>

    <div class="checkbox checkbox--azul">
      <input
        :disabled="!editando"
        type="checkbox"
        id="no-aplica"
        v-model="form.noAplicaHorasFuncionario"
      >
      <label class="form__label" for="no-aplica">
        No aplica
      </label>
    </div>
  </form>
</template>

<script>
import moment from "moment";

function horasFuncionario() {
  let resp;
  if (this.form.noAplicaHorasFuncionario) {
    resp = "No aplica";
  } else {
    const funcionarios = this.form.funcionariosParticipantes.filter(v => !!v);
    const inicio = moment(this.form.horaInicio).set({ second: 0, millisecond: 0 });
    const fin = moment(this.form.horaFinalizacion).set({ second: 0, millisecond: 0 });
    const duration = moment.duration(fin.diff(inicio));
    for (let i = 0; i < funcionarios.length; i += 1) {
      fin.add({ hour: duration._data.hours, minutes: duration._data.minutes });
    }
    const total = moment.duration(fin.diff(inicio));
    const horas = total._data.hours;
    const minutos = total._data.minutes;
    if (horas === 0) {
      resp = `${minutos} minutos`;
    } else if (minutos === 0) {
      resp = `${horas} horas`;
    } else {
      resp = `${horas} horas con ${minutos} minutos`;
    }
  }
  this.form.horasFuncionario = resp;
  return resp;
}

function visitaSoloHandler(val) {
  if (val) {
    this.form.funcionariosParticipantes = ["", "", ""];
  }
}

export default {
  name: "FormularioFinal",
  computed: {
    horasFuncionario,
  },
  props: {
    editando: Boolean,
    submitted: Boolean,
    form: Object,
    indice: Number,
    seguimiento: Boolean,
  },
  methods: {
    validar,
    copiarAcompanante,
  },
  mounted() {
    if (!this.form.horaFinalizacion) {
      this.form.horaFinalizacion = moment().format();
    }
  },
  watch: {
    "form.visitaSolo": visitaSoloHandler,
  },
};

function validar() {
  return this.$validator.validate();
}

function copiarAcompanante() {
  this.form.nomPersonaContacto = this.form.nomPersonaAcompanante;
  this.form.telPersonaContacto = this.form.telPersonaAcompanante;
}
</script>
